import {STATIC_DATA_TYPE} from "./static-data.enum";
import { ActiveTableKeyType } from "../interfaces/static-data";

export const STATIC_DATA_WORKFLOW_MAP = {
  [STATIC_DATA_TYPE.REFERENCE_ENTITY]:"ReferenceEntitySdScreen",
  [STATIC_DATA_TYPE.REFERENCE_OBLIGATION]:"ReferenceObligationSdScreen",
  [STATIC_DATA_TYPE.UNDERLYING_ASSETS]:"UnderlyingAssetsSdScreen",
  [STATIC_DATA_TYPE.ISSUERS_ENTITY]:"IssuersSdScreen",
  [STATIC_DATA_TYPE.LEGAL_PROGRAMMES]:"LegalProgramsSdScreen",
  [STATIC_DATA_TYPE.AGENTS]:"AgentsSdScreen",
  [STATIC_DATA_TYPE.DISTRIBUTORS]:"DistributorsSdScreen",
  [STATIC_DATA_TYPE.DISTRIBUTOR_GROUPS]:"DistributorGroupsSdScreen",
  [STATIC_DATA_TYPE.CURRENCIES]:"CurrenciesSdScreen",
  [STATIC_DATA_TYPE.LISTING_VENUES]:"ListingVenuesSdScreen",
}

export const STATIC_DATA_WORKFLOW_MAP_V2 = {
  [STATIC_DATA_TYPE.REFERENCE_ENTITY]:"ReferenceEntity",
  [STATIC_DATA_TYPE.REFERENCE_OBLIGATION]:"ReferenceObligations",
  [STATIC_DATA_TYPE.UNDERLYING_ASSETS]:"UnderlyingAsset",
  [STATIC_DATA_TYPE.ISSUERS_ENTITY]:"Issuer",
  [STATIC_DATA_TYPE.LEGAL_PROGRAMMES]:"legalProgramme",
  [STATIC_DATA_TYPE.AGENTS]:"Agent",
  [STATIC_DATA_TYPE.DISTRIBUTORS]:"Distributors",
  [STATIC_DATA_TYPE.DISTRIBUTOR_GROUPS]:"DistributorGroups",
  [STATIC_DATA_TYPE.CURRENCIES]:"Currencies",
  [STATIC_DATA_TYPE.LISTING_VENUES]:"ListingVenues",
}

export const APPROVALS_TEAMS_PER_STATIC_DATA_TYPE: {[key: string]: STATIC_DATA_TYPE[]} = {
  OpsSdApproval: [
    STATIC_DATA_TYPE.REFERENCE_ENTITY,
    STATIC_DATA_TYPE.REFERENCE_OBLIGATION,
    STATIC_DATA_TYPE.UNDERLYING_ASSETS,
    STATIC_DATA_TYPE.ISSUERS_ENTITY,
    STATIC_DATA_TYPE.LEGAL_PROGRAMMES,
    STATIC_DATA_TYPE.AGENTS,
    STATIC_DATA_TYPE.DISTRIBUTORS,
    STATIC_DATA_TYPE.DISTRIBUTOR_GROUPS,
    STATIC_DATA_TYPE.LISTING_VENUES
  ],
  SalesSdApproval: [
    STATIC_DATA_TYPE.REFERENCE_ENTITY,
    STATIC_DATA_TYPE.REFERENCE_OBLIGATION,
    STATIC_DATA_TYPE.UNDERLYING_ASSETS,
  ],
  TradingSdApproval: [
    STATIC_DATA_TYPE.REFERENCE_ENTITY,
    STATIC_DATA_TYPE.REFERENCE_OBLIGATION,
    STATIC_DATA_TYPE.UNDERLYING_ASSETS,
  ]
}
